import { render, staticRenderFns } from "./TabFamily.vue?vue&type=template&id=14576944&"
import script from "./TabFamily.vue?vue&type=script&lang=js&"
export * from "./TabFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports